import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Navigation.less';

const Navigation = props => (
  <div
    className={classNames(
      'navigation',
      { primary: props.primary, transparent: props.transparent },
      props.className,
    )}
  >
    {props.children}
  </div>
);

Navigation.defaultProps = {
  transparent: false,
  primary: false,
  className: '',
};

Navigation.propTypes = {
  transparent: PropTypes.bool,
  primary: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.array]).isRequired,
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/ui/Navigation/Navigation.js